import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './main.scss';
import ReactGA from 'react-ga4';
import { GA_MEASUREMENT_ID, BORROWER_ONBOARDING_URL } from '@common/config/environments';
import { sentryInit } from './sentry/main';

sentryInit();

// Solo habilitar GA en el host de onboarding (misma lógica que index.html)
const isOnboardingHost =
  BORROWER_ONBOARDING_URL &&
  BORROWER_ONBOARDING_URL.indexOf('REACT_APP_') !== 0 &&
  typeof window !== 'undefined' &&
  window.location.href.startsWith(BORROWER_ONBOARDING_URL);
const hasValidGaId =
  GA_MEASUREMENT_ID && GA_MEASUREMENT_ID.indexOf('REACT_APP_') !== 0;

if (isOnboardingHost && hasValidGaId) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
